<template>
    <div class="user-revenue-list">
        <div class="head">
            <div class="area1 area">
                <div class="title">我的总收入</div>
                <div style="margin-top:35px;">
                    <div class="area-block">
                        <div style="color:rgba(34, 215, 187, 1)">￥{{totalIncomeInfo.moneyRight}}</div>
                        <div>总正确收入</div>
                    </div>
                    <div class="area-block">
                        <div style="color:rgba(255, 70, 70, 1)">￥{{totalIncomeInfo.moneyError}}</div>
                        <div>总错误收入</div>
                    </div>
                </div>
                <div style="margin-top:45px">
                    <div class="area-block">
                        <div style="color:rgba(255, 195, 0, 1)">￥{{totalIncomeInfo.moneyDoubt}}</div>
                        <div>总存疑收入</div>
                    </div>
                    <div class="area-block">
                        <div style="color:rgba(24, 144, 255, 1)">￥{{totalIncomeInfo.totalMoney}}</div>
                        <div>总收入</div>
                    </div>
                </div>
            </div>
            <div class="area2 area">
                <div class="title">我的每日总收入统计</div>
                <div style="height:200px;width:100%;display:block" id="myChart1"></div>
            </div>
            <div class="area3 area">
                <div class="title">用户今日完成标注数量排名</div>
                <div style="height:200px" id="myChart2"></div>
            </div>
        </div>
        <div class="content">
            <div style="padding:0 24px">
                <div class="title">我的收入列表</div>
                <div class="condition-list">
                    <span @click="selectCondition('')" :class="{'active':dataCondition.status==''}">全部</span>
                    <span @click="selectCondition('TO_CHECK')" :class="{'active':dataCondition.status=='TO_CHECK'}">待审核</span>
                    <span @click="selectCondition('CHECKED')" :class="{'active':dataCondition.status=='CHECKED'}">已审核</span>
                </div>
            </div>
            <a-divider style="margin:10px 0 0px 0;color:#F7F7F7"/>
            <div style="clear:both"></div>
            <div style="padding:24px 24px 50px 24px;">
                <a-table :data-source="data" :pagination='false' :loading="ifShowLoading">
                    <a-table-column key="taskSeriesNo" title="任务编号" data-index="taskSeriesNo" />
                    <a-table-column key="project" title="所属项目" data-index="project" />
                    <a-table-column key="moneyRight" title="正收入" data-index="moneyRight" />
                    <a-table-column key="moneyError" title="负收入" data-index="moneyError" />
                    <a-table-column key="totalMoney" title="总收入" data-index="totalMoney" />
                    <a-table-column key="errorRate" title="错误率" data-index="errorRate">
                        <template slot-scope="text, record">
                            {{record.errorRate}}%
                        </template>
                    </a-table-column>
                    <a-table-column key="status" title="状态" data-index="status">
                        <template slot-scope="text, record">
                        <div>
                            <span style="color:rgba(34, 215, 187, 1)">{{record.status=='TO_CHECK'?'待审核':'已审核'}}</span>
                        </div>
                        </template>
                    </a-table-column>
                    <a-table-column key="createTime" title="创建时间" data-index="createTime" />
                    <a-table-column key="taskId" title="操作" data-index="taskId">
                        <template slot-scope="text, record">
                        <div>
                            <span style="color:rgba(34, 215, 187, 1);cursor:pointer" @click="exportExcel(record.taskId)">导出表格</span>
                        </div>
                        </template>
                    </a-table-column>
                </a-table>
                <div style="font-size:14px;margin-top:16px;float:left">
                    <span style="color:rgba(80, 80, 80, 1)">总计：</span>
                    <span style="color:rgba(24, 144, 255, 1)">{{total}}个</span>
                </div>
                <a-pagination
                    style="float:right;margin-top:16px"
                    v-model="dataCondition.current"
                    :page-size-options="pageSizeOptions"
                    :total="total"
                    show-size-changer
                    :page-size="dataCondition.size"
                    @showSizeChange="onShowSizeChange"
                    @change="onChangeSample"
                >
                    <template slot="buildOptionText" slot-scope="props">
                        <span>{{ props.value }}条/页</span>
                    </template>
                </a-pagination>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'UserRevenueList',
    props: {
        msg: String
    },
    data() {
        return {
            data: [],
            ifShowLoading: false,
            pageSizeOptions: ['10', '20', '50', '100'],
            total: 0,
            totalIncomeInfo: {},
            dataCondition: {
                status: '',
                current: 1,
                size: 10,
            }
        }
    },
    methods: {
        drawLine1(data){
            let dataX = [], dataY = []
            for(let i = 0; i < data.length; i++){
                dataX.push(data[i]['date'])
                dataY.push(data[i]['money'])
            }
            let myChart = this.$echarts.init(document.getElementById('myChart1'))
            myChart.setOption({
                xAxis: {
                    type: 'category',
                    data: dataX,
                    axisLine: {
                        lineStyle:{
                        color:'#E0E0E0',//x轴的颜色
                        width:1,//轴线的宽度  
                        }
                    },
                    axisLabel: {
                        show: true,
                        textStyle: {
                        color: '#939393'
                        }
                    },
                },
                dataZoom: [{
                    type: 'inside'
                }],
                tooltip : {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#6a7985'
                        }
                    }
                },
                yAxis: {
                    type: 'value',
                    axisLine: {
                        lineStyle:{
                            color:'#E0E0E0',//x轴的颜色
                            width:0,//轴线的宽度  
                        }
                    },
                    axisLabel: {
                        show: true,
                        textStyle: {
                        color: '#939393'
                        }
                    },
                    splitLine:{  
                        show:true ,
                        lineStyle:{
                        color:'#eee',
                        width: 1
                        }
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    top: '15%',
                    containLabel: true
                },
                series: [{
                    data: dataY,
                    type: 'bar',
                    smooth: true,
                    symbol: 'circle',//折线点设置为实心点
                    symbolSize: 4,   //折线点的大小
                    itemStyle: {
                        normal: {
                            color: "rgba(52, 139, 247, 1)",//折线点的颜色
                            lineStyle: {
                            color: "rgba(52, 139, 247, 1)"//折线的颜色
                            }
                        }
                    }
                }]
            });
        },
        drawLine2(data){
            let dataX = [], dataY = []
            for(let i = 0; i < data.length; i++){
                dataX.push(data[i]['name'])
                dataY.push(data[i]['count'])
            }
            let myChart = this.$echarts.init(document.getElementById('myChart2'))
            myChart.setOption({
                xAxis: {
                    type: 'category',
                    data: dataX,
                    axisLine: {
                        lineStyle:{
                        color:'#E0E0E0',//x轴的颜色
                        width:1,//轴线的宽度  
                        }
                    },
                    axisLabel: {
                        show: true,
                        textStyle: {
                        color: '#939393'
                        }
                    },
                },
                dataZoom: [{
                    type: 'inside'
                }],
                tooltip : {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#6a7985'
                        }
                    }
                },
                yAxis: {
                    type: 'value',
                    axisLine: {
                        lineStyle:{
                        color:'#E0E0E0',//x轴的颜色
                        width:0,//轴线的宽度  
                        }
                    },
                    axisLabel: {
                        show: true,
                        textStyle: {
                        color: '#939393'
                        }
                    },
                    splitLine:{  
                        show:true ,
                        lineStyle:{
                        color:'#eee',
                        width: 1
                        }
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    top: '15%',
                    containLabel: true
                },
                series: [{
                    data: dataY,
                    type: 'bar',
                    smooth: true,
                    symbol: 'circle',//折线点设置为实心点
                    symbolSize: 4,   //折线点的大小
                    itemStyle: {
                        normal: {
                            color: "rgba(52, 139, 247, 1)",//折线点的颜色
                            lineStyle: {
                            color: "rgba(52, 139, 247, 1)"//折线的颜色
                            }
                        }
                    }
                }]
            });
        },
        selectCondition(type) {
            this.dataCondition.status = type
            this.queryData()
        },
        queryData() {
            this.axios({
                url: '/api/user/accountRecord/list', 
                method: 'get',
                params: {
                    current: this.dataCondition.current,
                    size: this.dataCondition.size,
                    status: this.dataCondition.status,
                }
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.data = response.data.data.records
                    this.total = response.data.data.total
                }else{
                    this.$parent.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        exportExcel(id) {
            this.axios({
                url: '/api/user/task/export', 
                method: 'get',
                responseType: 'arraybuffer',
                params: {
                    id: id,
                }
            })
            .then(response=> {
                this.$parent.success('导出成功');
                this.download(response.data)
            })
            .catch(error=> {
                console.log(error)
            })
        },
        download(data) {
            if (!data) {
                return
            }
            const url = window.URL.createObjectURL(new Blob([data]))
            let link = document.createElement('a')
            link.style.display = 'none'
            link.href = url
            link.setAttribute('download', '我的收入列表.csv')
            document.body.appendChild(link)
            link.click()
            URL.revokeObjectURL(link.href) // 释放URL 对象
            document.body.removeChild(link)
            link = null
        },
        onShowSizeChange(current, pageSize) {
            this.dataCondition.current = current
            this.dataCondition.size = pageSize;
            this.queryData()
        },
        onChangeSample(value) {
            this.dataCondition.current = value
            this.queryData()
        },
        queryIncomeData() {
            this.axios(
                {
                    method:'get',
                    url:'/api/user/statistic/money',
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.totalIncomeInfo = response.data.data
                }else{
                    this.$parent.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        queryDailyIncome() {
            this.axios(
                {
                    method:'get',
                    url:'/api/user/statistic/dayMoney',
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.drawLine1(response.data.data)
                }else{
                    this.$parent.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        queryUserRanking() {
            this.axios(
                {
                    method:'get',
                    url:'/api/user/statistic/finishWord',
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.drawLine2(response.data.data)
                }else{
                    this.$parent.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        }
    },
    mounted: function() {
        this.queryIncomeData()
        this.queryDailyIncome()
        this.queryUserRanking()
        this.queryData()
    }
}
</script>

<style scoped lang="less">
    .user-revenue-list{
        padding: 24px;
        background: rgba(245, 246, 247, 1);
        .head{
            display: flex;
            .area{
                background: #fff;
                border-radius: 4px;
                height: 260px;
                padding: 12px 24px;
                .title{
                font-size: 16px;
                color: rgba(51, 51, 51, 1);
                }
            }
            .area1{
                width: 440px;
                .area-block{
                display: inline-block;
                width: 50%;
                text-align: center;
                div:nth-child(1){
                    font-size:24px;
                    font-weight: bold;
                }
                div:nth-child(2){
                    font-size:14px;
                    color: rgba(170, 170, 170, 1);
                }
                }
            }
            .area2{
                flex: 1;
                margin: 0 16px;
            }
            .area3{
                width: 520px;
            }
        }
        .content{
            margin-top: 16px;
            padding: 12px 0;
            background:#fff;
            box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.04);
            border-radius: 4px;
            .title{
                font-size: 16px;
                color: rgba(51, 51, 51, 1);
                display: inline-block;
            }
            .condition-list{
                float: right;
                span{
                display:inline-block;
                padding: 0 19px 14px 19px;
                cursor: pointer;
                }
                span:nth-child(5){
                padding: 0 0px 14px 19px;
                }
                span:nth-child(5).active{
                padding: 0 19px 14px 19px;
                }
                span.active{
                color: rgba(24, 144, 255, 1);
                border-bottom: 3px solid rgba(24, 144, 255, 1);
                }
            }
        }
    }
</style>
